/**
 * Copyright Open Logistics Foundation
 *
 * Licensed under the Open Logistics Foundation License 1.3.
 * For details on the licensing terms, see the LICENSE file.
 * SPDX-License-Identifier: OLFL-1.3
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HistoryLog } from '@app/shared/models/ecmr/HistoryLog';
import { EcmrUrlResolverService } from './ecmr-url-resolver.service';

@Injectable({
    providedIn: 'root',
})
export class HistoryLogsService {
    constructor(
        private http: HttpClient,
        private ecmrUrlResolver: EcmrUrlResolverService
    ) {}

    getHistoryLogs(ecmrId: string) {
        return this.http.get<HistoryLog[]>(
            `${this.ecmrUrlResolver.getEcmrUrl()}/history/${ecmrId}`
        );
    }
}
